import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["isChecked", "isInvalid", "defaultChecked", "isDisabled", "label", "children", "onChange", "onBlur", "onFocus", "value", "name", "mode", "size", "id", "innerRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import uniqueId from '../../tools/uniqueId';
import { StyledRadio } from './Radio.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Radio = function (_React$Component) {
  _inherits(Radio, _React$Component);

  var _super = _createSuper(Radio);

  function Radio(props) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (evt) {
      _this.props.onChange(evt, _this.props.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (evt) {
      _this.props.onBlur(evt);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (evt) {
      _this.props.onFocus(evt);
    });

    _this.uid = _this.props.id || uniqueId('radio');
    return _this;
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isChecked = _this$props.isChecked,
          isInvalid = _this$props.isInvalid,
          defaultChecked = _this$props.defaultChecked,
          isDisabled = _this$props.isDisabled,
          label = _this$props.label,
          children = _this$props.children,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          value = _this$props.value,
          name = _this$props.name,
          mode = _this$props.mode,
          size = _this$props.size,
          id = _this$props.id,
          ref = _this$props.innerRef,
          rest = _objectWithoutProperties(_this$props, _excluded);

      return _jsx(ThemeProvider, {
        theme: {
          mode: mode,
          size: size
        },
        children: _jsxs(StyledRadio, {
          isDisabled: isDisabled,
          className: "dentsu-radio",
          children: [_jsx("input", _objectSpread({
            id: this.uid,
            ref: ref,
            type: "radio",
            onChange: this.handleChange,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            className: "dentsu-radio__input",
            disabled: isDisabled,
            value: value,
            name: name,
            checked: defaultChecked || isChecked,
            "data-invalid": isInvalid
          }, rest)), _jsxs("label", {
            htmlFor: this.uid,
            "aria-label": label,
            className: "dentsu-radio__label",
            children: [_jsx("span", {
              className: "dentsu-radio__indicator"
            }), _jsx("span", {
              className: "dentsu-radio__text",
              dangerouslySetInnerHTML: {
                __html: label
              }
            })]
          }), children && _jsx("div", {
            className: "dentsu-radio__description",
            children: children
          })]
        })
      });
    }
  }]);

  return Radio;
}(React.Component);

Radio.defaultProps = {
  value: '',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  isInvalid: false,
  isDisabled: false,
  mode: 'light',
  size: 'medium'
};
export default (function () {
  var forwardRef = function forwardRef(props, ref) {
    return _jsx(Radio, _objectSpread(_objectSpread({}, props), {}, {
      innerRef: ref
    }));
  };

  forwardRef.displayName = 'Radio';
  return React.forwardRef(forwardRef);
})();